<template>
  <div>
    <div class="mb-2 d-flex justify-space-between align-center">
      <div>
        <span class="text-uppercase text-body-2">{{ title || '' }}:</span>
        <span class="ml-2 text-body-1 font-weight-medium">{{ list.length }}</span>
      </div>
    </div>
    <div class="imei-list">
      <div v-for="(item, index) in list" :key="index" class="imei-list__item">
        <span>
          {{ item }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => {}
    },
    listType: {
      type: String,
      default: 'total',
      enum: ['matched']
    },
    title: String
  },
  methods: {
    confirm() {
      this.$dialog.confirm({
        title: 'Xác nhận nhập mã IMEI không khớp',
        text: 'Các mã IMEI này không có trong danh sách ban đầu. Bạn có muốn nhập các mã này vào không?',
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: () => {
          this.$emit('onConfirmCheckMismatched')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 8px;
}
.imei-list {
  text-align: justify;
  overflow-y: auto;
  height: 77px;
  padding: 8px;
  background: #eee;
  .imei-list__item {
    display: inline-block;
    margin-right: 16px;
  }
}
</style>
